import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '@/hooks/useCustomTheme';

interface IconWithCircleProps extends BoxProps {
  children: React.ReactNode;
  iconProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
}

export const IconWithCircle = ({ children, iconProps, ...props }: IconWithCircleProps) => {
  const { customBorderRadius } = useCustomTheme();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" borderRadius={customBorderRadius.chip} {...props}>
      <i className="material-icons-outlined" {...iconProps}>
        {children}
      </i>
    </Box>
  );
};
